import { Col, Row, Table } from "antd";
import { useTranslation } from "react-i18next";
import { MdOpenInNew, MdOutlineDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { SCREENS } from "utils/constants";

function List({ data, count, setValues, skip }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRODUCT_RANGE);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.CODE,
      dataIndex: "code",
    },
    {
      title: LIST.LABEL,
      dataIndex: "label",
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.DETAIL.path}/${id}`,
              )
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.DELETE.path}/${id}`,
              )
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey={"id"}
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
